import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DealHistoryDrawer } from '@makemydeal/dr-activities-deal-history';
import * as dealHistoryActionCreators from '@makemydeal/dr-dash-store/actions/dealHistoryActionCreator';
import * as dealHistorySelectors from '@makemydeal/dr-dash-store/selectors/dealHistorySelectors';

export const DealHistoryDrawerContainer: React.FC = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(dealHistorySelectors.isDealHistoryDrawerOpen);

    const handleClose = () => {
        dispatch(dealHistoryActionCreators.closeDealHistoryDrawer());
    };

    return <DealHistoryDrawer isOpen={isOpen} onClose={handleClose} />;
};
